import React from 'react';
import { useQuery } from '@apollo/client';
import GET_USER from 'graphql/getUser';

export function useUser() {
  const { loading, data } = useQuery(GET_USER);

  const userWithFirm = React.useMemo(() => {
    const firm = data?.firm;
    const user = data?.user;
    return { ...user, firm };
  }, [data]);

  return [loading, userWithFirm];
}
